import { ProjectActionType, IProjectState, ProjectAction } from "../types/projectData"

const initialState: IProjectState = {
  projectData: [],
  loading: false,
  error: null,
}

export const projectDataReducer = (
  state: IProjectState = initialState,
  action: ProjectAction
): IProjectState => {
  switch (action.type) {
    case ProjectActionType.FETCH_PROJECT_DATA:
      return { ...state, loading: true }
    case ProjectActionType.FETCH_PROJECT_DATA_SUCCESS:
      return { ...state, projectData: action.payload, loading: false }
    case ProjectActionType.FETCH_PROJECT_DATA_ERROR:
      return { ...state, error: action.payload, loading: false }
    default:
      const exhaustiveCheck: never = action
      return state
  }
}

export default projectDataReducer
